import { SegmentInterface } from 'services/analytics/segment/types';

import { PinwheelEvents } from './helpers/PinwheelEvents';
import { PinwheelLinkSessionStateInterface } from './helpers/PinwheelLinkSessionState';
import { PinwheelSolutionType } from './helpers/pinwheelSolutionType.helpers';

export const pinwheelSegmentEventNames = {
  [PinwheelEvents.SelectEmployer as string]:
    'Direct Deposit Instant Switch Employer Selected',
  [PinwheelEvents.SelectPlatform as string]:
    'Direct Deposit Instant Switch Platform Selected',
  [PinwheelEvents.LoginAttempt as string]:
    'Direct Deposit Instant Switch Login Attempted',
  [PinwheelEvents.Login as string]:
    'Direct Deposit Instant Switch Login Succeeded',
  [PinwheelEvents.InputAmount as string]:
    'Direct Deposit Instant Switch Amount Inputted',
  [PinwheelEvents.Success as string]: 'Direct Deposit Instant Switch Completed',
  [PinwheelEvents.PinWheelError as string]:
    'Direct Deposit Instant Switch Error Occurred',
  [PinwheelEvents.DdFormBegin as string]:
    'Direct Deposit Form Creation Initiated',
  [PinwheelEvents.DdFormCreate as string]: 'Direct Deposit Create Form Clicked',
  [PinwheelEvents.DdFormDownload]: 'Direct Deposit Form Download Clicked',
  [PinwheelEvents.InputAllocation as string]:
    'Direct Deposit Instant Switch Amount Inputted',
  [PinwheelEvents.SearchDefault]:
    'Direct Deposit Instant Switch Search Default',
  [PinwheelEvents.SearchResults]:
    'Direct Deposit Instant Switch Search Results',
  [PinwheelEvents.SearchPlatform]:
    'Direct Deposit Instant Switch Search Platform',
  [PinwheelEvents.ProviderConfirmation]:
    'Direct Deposit Instant Switch Provider Confirmation',
  [PinwheelEvents.DDAmountSelection]:
    'Direct Deposit Instant Switch Amount Selection',
  [PinwheelEvents.DDConfirmation]: 'Direct Deposit Instant Switch Confirmation',
  [PinwheelEvents.PLATFORM_ELIGIBILITY_LOOKUP_LOADING]:
    'PreMatch Platform Eligibility Lookup Loading',
  [PinwheelEvents.JobSuccess]: 'Direct Deposit Instant Switch Successful',
  [PinwheelEvents.JobError]: 'Direct Deposit Instant Switch Error Encountered',
  [PinwheelEvents.ExitConfirmation]:
    'Direct Deposit Instant Switch Exit Confirmation',
  [PinwheelEvents.LookupResult]: 'PreMatch Platform Eligibility Lookup Results',
  [PinwheelEvents.LookupHelp]: 'PreMatch Platform Eligibility Lookup Help',
  abandoned: 'Direct Deposit Instant Switch Abandoned',
};

export type PinwheelScreenTransitionPayload = {
  screenName: string;
  selectedEmployerId?: string;
  selectedEmployerName?: string;
  selectedPlatformId?: string;
  selectedPlatformName?: string;
};

export interface PinwheelTarget {
  accountType: string;
  accountName?: string;
}

export interface PinwheelAllocation {
  type: string;
  value?: number;
  target?: PinwheelTarget;
}

export interface PinwheelInputAllocationPayload {
  action?: string;
  allocation?: PinwheelAllocation;
}

export interface PinwheelModalOutcome {
  isEarlyExit?: boolean;
  hasPinwheelErrorEvent?: boolean;
  hasLoginSuccess?: boolean;
  sessionState?: PinwheelLinkSessionStateInterface;
}

export interface PinWheelModalWrapperProps {
  token: string;
  linkTokenId: string;
  onOpen: () => void;
  onAbruptExit: (outcome: PinwheelModalOutcome) => void;
  solutionType?: PinwheelSolutionType;
  sourceName?: string;
  segmentClient: SegmentInterface;
}
